import { Route, Routes } from 'react-router-dom'

import List from './screens/List'

const TemplatePagePartialsRoutes = () => (
  <Routes>
    <Route path="/" element={<List />} />
  </Routes>
)

export default TemplatePagePartialsRoutes
